import { Reveal } from "@/components/Reveal";
import { JOTFORM_URL, PARTNER_FORM_URL } from "@/constants";

const Footer = () => (
    <footer
        data-testid="site-footer"
        className="relative overflow-hidden border-t border-[#270057]/15"
    >
        <div className="royal-flare absolute inset-x-0 bottom-0 h-[60vh] rotate-180 opacity-80" />

        <div className="relative mx-auto max-w-[1500px] px-6 pb-12 pt-32 text-center lg:px-16 lg:pt-44">
            <Reveal>
                <p className="mb-10 font-display text-[10px] uppercase tracking-[0.5em] text-[#270057]">
                    Begin the Commission
                </p>
                <a
                    href={JOTFORM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-commission-project-button"
                    className="group inline-block"
                >
                    <span className="font-serif text-[11vw] font-normal leading-[1.05] tracking-[-0.02em] text-[#270057] sm:text-[9vw] lg:text-[6.5vw]">
                        Commission
                        <br />
                        <em className="text-royal-outline italic transition-all duration-700 group-hover:[-webkit-text-stroke-color:rgba(39,0,87,0.9)]">
                            a Project
                        </em>
                    </span>
                </a>
            </Reveal>

            <Reveal delay={0.1}>
                <div className="mx-auto mt-28 grid max-w-5xl grid-cols-1 gap-12 border-t border-[#270057]/15 pt-16 text-left sm:grid-cols-3 sm:gap-10">
                    <div data-testid="footer-studio-identity">
                        <h3 className="font-sans text-[11px] font-semibold uppercase tracking-[0.3em] text-[#270057]">
                            The Atelier
                        </h3>
                        <p className="mt-5 text-base font-normal leading-relaxed text-[#270057]">
                            Vellor Studio LLP
                            <br />
                            Specialized Offline Video Editing Atelier
                        </p>
                    </div>
                    <div data-testid="footer-address">
                        <h3 className="font-sans text-[11px] font-semibold uppercase tracking-[0.3em] text-[#270057]">
                            Visit
                        </h3>
                        <p className="mt-5 text-base font-normal leading-relaxed text-[#270057]">
                            Office No. 2, First Floor, Sumati Paradise, Plot
                            No. 227, Near Carnival Restaurant, Sector R4,
                            Vadghar, Karanjade, Panvel, Navi Mumbai - 410 206,
                            Maharashtra, India
                        </p>
                    </div>
                    <div data-testid="footer-direct-contact">
                        <h3 className="font-sans text-[11px] font-semibold uppercase tracking-[0.3em] text-[#270057]">
                            Direct Contact
                        </h3>
                        <p className="mt-5 text-base font-normal leading-relaxed text-[#270057]">
                            <a
                                href="tel:+918655949263"
                                data-testid="footer-phone-link"
                                className="transition-colors duration-500 hover:text-[#270057]"
                            >
                                +91 86559 49263
                            </a>
                            <br />
                            <a
                                href="mailto:connect@vellorstudio.com"
                                data-testid="footer-email-link"
                                className="transition-colors duration-500 hover:text-[#270057]"
                            >
                                connect@vellorstudio.com
                            </a>
                        </p>
                    </div>
                </div>
            </Reveal>

            <div className="mt-20 flex flex-col items-center gap-6 border-t border-[#270057]/15 pt-10 sm:flex-row sm:justify-between">
                <p
                    data-testid="footer-copyright"
                    className="font-sans text-[11px] font-normal tracking-[0.15em] text-[#270057]"
                >
                    © 2026 Vellor Studio LLP. All Rights Reserved. Governed by
                    Vision, Verity, and Vault.
                </p>
                <div className="flex items-center gap-10">
                    <a
                        href={PARTNER_FORM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-partnerships-link"
                        className="font-sans text-[11px] font-medium uppercase tracking-[0.25em] text-[#270057] transition-colors duration-500 hover:text-[#270057]"
                    >
                        Partnerships
                    </a>
                    <a
                        href={JOTFORM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-contact-us-link"
                        className="group inline-flex items-center gap-3 font-sans text-[11px] font-medium uppercase tracking-[0.25em] text-[#270057] transition-colors duration-500 hover:text-[#270057]"
                    >
                        Contact Us
                        <span className="block h-px w-8 bg-[#270057]/50 transition-all duration-500 group-hover:w-12 group-hover:bg-[#270057]" />
                    </a>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
